function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M20.16 8.667v6.666c0 .92-.819 1.667-1.829 1.667H2.79C1.779 17 .96 16.254.96 15.333V8.667C.96 7.747 1.779 7 2.789 7H18.33c1.01 0 1.829.746 1.829 1.667m.96.833h.96c.53 0 .96.373.96.833v3.334c0 .46-.43.833-.96.833h-.96z",
  clipRule: "evenodd"
}));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/location/ic-battery.svg";
export { SvgComponent as ReactComponent };